<template>
  <div :key="$store.getters['resource/currentResource'].key">

    <v-server-table
      ref="appTable"
      name="resourcesTable"
      class="white-container"
      url="/admin/resources"
      :columns="columns"
      :options="options"
      @loaded="loading = false"
      @loading="loading = true">

      <template slot="beforeLimit" v-if="totalRecordsCount > 10">
        {{$t('global.showing')}}&nbsp;
      </template>
      <template slot="afterLimit" v-if="totalRecordsCount > 10">
        &nbsp;{{$t('global.of_records_found', {number: totalRecordsCount})}}
      </template>

      <template slot="active" slot-scope="props">
        <column-check :row="props.row" column="active" active="active"/>
      </template>

      <template slot="live_stripe_connect" slot-scope="props">
        <column-check :row="props.row" column="live_stripe_connect" active="live_stripe_connect"/>
      </template>

      <template slot="test_stripe_connect" slot-scope="props" class="test">
        <column-check :row="props.row" column="test_stripe_connect" active="test_stripe_connect"/>
      </template>

      <template slot="actions" slot-scope="props">
        <column-action
          :deleteUrl="`/resources/${props.row.id}`"
          @deleteItems="refreshTable('appTable')"
          :route="{path: `/resources/edit?resource=${props.row.key}`, params: {id: props.row.id}}"
        />
      </template>
    </v-server-table>
  </div>

</template>

<script>
  import axios from '@/utils/axios';
  import {Event} from 'vue-tables-2';
  import i18n from "@/utils/i18n";

  export default {
    middleware: 'auth',
    name: 'Resources',
    data: () => {
      return {
        loading: false,
        totalRecordsCount: null,
        params: {
          page: 1,
          filter: {}
        },
        columns: ['key', 'title', 'host', 'active', 'live_stripe_connect', 'test_stripe_connect', 'actions'],
        filters: [],
        options: {
          skin: [],
          headings: {
            key: i18n.t('resources.key'),
            title: i18n.t('form.title'),
            host: i18n.t('resources.host'),
            active: i18n.t('form.active'),
            actions: i18n.t('button.edit'),
            live_stripe_connect: function (h) {
              return this.$createElement('span', {class: 'd-inline-block', style: 'width: 150px'}, i18n.t('resources.live_stripe_connect'));
            },
            test_stripe_connect: function (h) {
              return this.$createElement('span', {class: 'd-inline-block', style: 'width: 150px'}, i18n.t('resources.test_stripe_connect'));
            }
          },
          sortable: [],
          dateColumns: ['created_at'],
          columnsDropdown: false,
          filterByColumn: false,
          customFilters: ['custom'],
          perPage: !!localStorage.getItem('perPage') && localStorage.getItem('perPage') !== '' ? localStorage.getItem('perPage') : 10,
          filterable: false,
          requestFunction: function (data) {
            localStorage.setItem('perPage', data.limit);
            return axios.get(this.url, {
              params: {
                filter: data.custom,
                limit: data.limit,
                page: data.page
              }
            }).catch((e) => {
              // this.$noty.error(e.error_description);
              this.dispatch('error', e);
            });
          },
          responseAdapter: function (resp) {
            let data = this.getResponseData(resp);
            return {
              data: data.data.items,
              count: data.data.paginator.total_items
            }
          }
        },
      }
    },
    mounted() {
      Event.$on('vue-tables.resourcesTable.loaded', ({data}) => {
        this.totalRecordsCount = data.paginator.total_items
      });
    },
    methods: {
      filter(params) {
        this.params = params;
        Event.$emit('vue-tables.resourcesTable.filter::custom', params)
      }
    },
    destroyed() {
      Event.$off('vue-tables.resourcesTable.loaded');
    }
  }
</script>
